module.exports = __webpack_public_path__ + "static/media/tounge.cff2283c.svg";